<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="单号">
              <a-input v-model="queryParam.orderNo" />
            </a-form-item>
          </a-col>

          <!--          <a-col :span="6">-->
          <!--            <a-form-item label="申请状态">-->
          <!--              <a-input v-model="queryParam.shippingNo"/>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :span="6">
            <a-form-item label="物流公司">
              <a-select v-model="queryParam.transportCode" allowClear="true">
                <a-select-option v-for="type in restaurantTypes" :title="type.label" v-bind:value="type.label">{{
                  type.label
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="配件">
              <a-select @change="onchange2" v-model="queryParam.accessoryId" allowClear="true">
                <a-select-option v-for="item in boxLis5" :title="item.accessoryName" :value="item.accessoryId">{{
                  item.accessoryName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="付款方式">
              <a-select v-model="queryParam.payment" allowClear="true">
                <a-select-option value="先付款">先付款</a-select-option>
                <a-select-option value="后付款">后付款</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="是否开票">
              <a-select v-model="queryParam.invoice" allowClear="true">
                <a-select-option value="0">不开票</a-select-option>
                <a-select-option value="1">开票</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="物流状态">
              <a-select v-model="queryParam.transportStatus" allowClear="true">
                <a-select-option :value="0">未发货</a-select-option>
                <a-select-option :value="1">发货中</a-select-option>
                <a-select-option :value="2">确认收货</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!--            <a-col :span="6">-->
          <!--          <a-form-item label="物流公司">-->
          <!--            <a-select  v-model="queryParam.transportCode" allowClear="true">-->
          <!--              <a-select-option v-for="type in restaurantTypes" :title="type.label" v-bind:value="type.code">{{type.label}}</a-select-option>-->
          <!--            </a-select>-->
          <!--          </a-form-item>-->
          <!--        </a-col>-->

          <a-col :span="6">
            <a-form-item label="配件单类型">
              <a-select v-model="queryParam.orderType" allowClear="true">
                <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.label">{{
                  type.label
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="物流单号">
              <a-input v-model="queryParam.transportNo" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <!--          <a-col :span="6">-->
          <!--            <a-form-item label="物流状态">-->
          <!--              <a-select    v-model="queryParam.transportStatus" allowClear="true">-->
          <!--                <a-select-option :value="0">未发货</a-select-option>-->
          <!--                <a-select-option :value="1">发货中</a-select-option>-->
          <!--                <a-select-option :value="2">确认收货</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :span="6">
            <a-form-item label="申请人">
              <a-input v-model="queryParam.createBy" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="操作人">
              <a-input v-model="queryParam.updateBy" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="选择时间">
              <a-select @change="onChangeTiem6" v-model="time2" :allowClear="true" style="width: 35%">
                <a-select-option value="0">需求时间</a-select-option>
                <a-select-option value="1">申请时间</a-select-option>
                <a-select-option value="2">采购时间</a-select-option>
                <a-select-option value="3">期望付款时间</a-select-option>
                <a-select-option value="4">预期到货时间</a-select-option>
                <a-select-option value="5">付款完成时间</a-select-option>
              </a-select>
              <a-range-picker @change="onChangeTiem5" v-model="timess3" style="width: 55%" />
            </a-form-item>
          </a-col>

          <a-col :span="16">
            <a-form-item label="选择时间">
              <a-select @change="onChangeTiem4" v-model="time3" :allowClear="true" style="width: 15%">
                <a-select-option value="0">需求时间</a-select-option>
                <a-select-option value="1">申请时间</a-select-option>
                <a-select-option value="2">采购时间</a-select-option>
                <a-select-option value="3">期望付款时间</a-select-option>
                <a-select-option value="4">预期到货时间</a-select-option>
                <a-select-option value="5">付款完成时间</a-select-option>
              </a-select>
              <a-range-picker @change="onChangeTiem5" v-model="timess2" style="width: 30%; margin-right: 30px" />
              <span style="float: right">
                <a-button htmlType="submit" type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="handClear">清空</a-button>
              </span>
            </a-form-item>
          </a-col>
        </a-row>
        <!--        <span class="table-page-search-submitButtons">-->
        <!--               <a-row type="flex" justify="space-between">-->
        <!--            <a-col :span="15"></a-col>-->
        <!--            <a-col :span="6"  style="text-align: right">-->
        <!--              <a-button type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">查询</a-button>-->
        <!--              <a-button style="margin-left: 8px" @click="handClear">清空</a-button>-->
        <!--            </a-col>-->
        <!--             </a-row>-->
        <!--            </span>-->
      </a-form>
    </div>

    <div class="table-operator">
      <a-row type="flex" justify="space-between">
        <a-col :span="16"></a-col>
        <a-col :span="4" style="text-align: right">
          <a-button value="0" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
        </a-col>
        <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
          <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
        </a-dropdown>
      </a-row>
    </div>

    <!--    <div class="table-operator">-->
    <!--      <a-row  type="flex" justify="space-between">-->
    <!--        <a-col :span="16"></a-col>-->
    <!--        <a-col :span="4">-->
    <!--      <a-button value="0"  type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>-->
    <!--        </a-col>-->
    <!--      <a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
    <!--        <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>-->
    <!--      </a-dropdown>-->
    <!--    </div>-->
    <s-table
      size="default"
      ref="table"
      rowKey="accessoryId2"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: '1600px' }"
      bordered
    >
      <span slot="transportStatus" slot-scope="text, record">
        <a-text v-if="record.transportStatus == 0">未发货 </a-text>
        <a-text v-else-if="record.transportStatus == 1">发货中</a-text>
        <a-text v-else-if="record.transportStatus == 2">确认收货</a-text>
        <a-text v-else="record.transportStatus == null"></a-text>
      </span>

      <span slot="commonFlag" slot-scope="text, record">
        <a-text v-if="record.commonFlag == 0">通用 </a-text>
        <a-text v-else="record.commonFlag == 1">不通用</a-text>
      </span>

      <span slot="action" slot-scope="text, record">
        <a v-if="record.operateType == 0" @click="handleEdit(record)">查看</a>
        <a v-if="record.operateType == 1" @click="handleEdit(record)">编辑</a>
        <!-- <a v-if="editEnabel  && record.completeStatus  != '已审核'  && record.operateType ==0 " @click="handleEdit(record)">编辑</a>
              <a v-if="editEnabel && record.completeStatus == '已审核' && record.operateType == 0 " @click="handleEdit(record)">查看</a>-->
        <a v-if="record.operateType == 3" @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" v-if="record.operateType == 3" />
        <a v-if="record.operateType == 3" @click="handleEdit2(record)">审核</a>

        <a-divider type="vertical" />
        <!--        <a  @click="detailBtn(record)">作废</a>-->
        <a @click="detailBtn(record)" v-if="record.forbiddenStatus == 0">作废</a>
        <a @click="detailBtn(record)" v-if="record.forbiddenStatus == 1">恢复</a>
        <a-divider type="vertical" />

        <a @click="delByIds(record)">删除</a>
      </span>
    </s-table>
    <commodity-modal ref="modal" @ok="handleOk(arguments, userDefined)" />
    <commodity-condiments-model ref="modal2" @ok2="handleOk2(arguments, userDefined)" />
    <allocation-modal ref="modal3" @ok3="handleOk3(arguments, userDefined)" />

    <!--    <commodityCondiments-modal ref="modal2" @ok="handleOk"/>-->
  </a-card>
</template>

<script>
import { STable } from '@/components'
import {
  selectaccessory,
  delorder,
  forbiddenorder,
  selectorderlist,
  getAccessoryList,
  addAccessory,
  delAccessoryTwo,
  delAccessory1,
  selectenterprise,
  selectenterprise2,
  configSave
} from '@/api/accessory/commodity'
import commodityModal from './modules/commodityModal.vue'
import commodityCondimentsModel from './modules/commodityCondimentsModel.vue'
import allocationModel from './modules/allocationModel.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import IconText from '../list/search/components/IconText'
import AllocationModal from './modules/allocationModel'

// const plainOptions = ['Apple', 'Pear', 'Orange'];
// const defaultCheckedList = ['Apple', 'Orange'];
export default {
  name: 'TableList',
  components: {
    AllocationModal,
    IconText,
    STable,
    commodityModal,
    commodityCondimentsModel,
    allocationModel
  },
  data() {
    return {
      // 时间查询
      time4: '',
      timess3: '',
      timess2: '',
      timess: '',
      accessoryId: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      accessory: {},
      form: this.$form.createForm(this),
      ids: '',
      modelAccessories: [],
      enterprise: [],
      dateModel: false,
      dateModel2: false,
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      boxLis: {},
      boxLis2: {},
      boxLis3: [],
      boxLis4: '',
      boxLis5: '',
      mdl: {},
      delFlag: 1,
      commonFlag: '',
      time2: '',
      time3: '',
      // 高级搜索 展开/关闭
      advanced: false,
      checkedList: false,
      indeterminate: true,
      checkAll: false,
      // plainOptions,
      //供应商ID
      supplierId: '',
      //订单Id
      orderId: '',
      //流程Id
      processInstanceId: '',
      //订单类型
      orderType: '',
      //作废状态
      forbiddenStatus: '',
      idsLis: '',
      //审核开始时间
      auditTimeStart: '',
      //申请开始时间
      createTimeStart: '',
      //需求开始时间
      needTimeStart: '',

      //审结束时间
      auditTimeEnd: '',
      //申请结束时间
      createTimeEnd: '',
      //需求结束时间
      needTimeEnd: '',
      // 查询参数
      queryParam: {},
      completionTimeStart: '',
      completionTimeEnd: '',

      timeBegin: '',
      timeEnd: '',

      expectedDeliveryTimeStart: '',
      expectedDeliveryTimeEnd: '',

      paymentCompletionTimeStart: '',
      paymentCompletionTimeEnd: '',
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '订单',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '申请状态',
          dataIndex: 'completeStatus',
          align: 'center'
        },
        {
          title: '需求时间',
          dataIndex: 'needTime',
          align: 'center'
        },
        {
          title: '期望付款起始时间',
          dataIndex: 'timeBegin',
          align: 'center'
        },
        {
          title: '采购完成时间',
          dataIndex: 'completionTime',
          align: 'center'
        },
        {
          title: '物流公司',
          dataIndex: 'transportCode',
          align: 'center'
        },
        {
          title: '物流单号',
          dataIndex: 'transportNo',
          align: 'center'
        },
        {
          title: '物流状态',
          dataIndex: 'transportStatus',
          scopedSlots: { customRender: 'transportStatus' },
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'updateBy',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center'
        }
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //
        // },
      ],

      // 加载数据方法 必须为 Promise 对象

      loadData: parameter => {
        parameter.needTimeStart = this.needTimeStart
        parameter.createTimeStart = this.createTimeStart
        parameter.auditTimeStart = this.auditTimeStart
        parameter.needTimeEnd = this.needTimeEnd
        parameter.createTimeEnd = this.createTimeEnd
        parameter.auditTimeEnd = this.auditTimeEnd
        parameter.completionTimeStart = this.completionTimeStart
        parameter.completionTimeEnd = this.completionTimeEnd

        parameter.timeBegin = this.timeBegin
        parameter.timeEnd = this.timeEnd

        parameter.expectedDeliveryTimeStart = this.expectedDeliveryTimeStart
        parameter.expectedDeliveryTimeEnd = this.expectedDeliveryTimeEnd

        parameter.paymentCompletionTimeStart = this.paymentCompletionTimeStart
        parameter.paymentCompletionTimeEnd = this.paymentCompletionTimeEnd
        return selectorderlist(Object.assign(parameter, this.queryParam))
      },
      // loadData:[],
      restaurantTypes: [],
      restaurantTypes2: [],
      selectedRowKeys: [],
      selectedRows: [],
      addEnable: checkPermission('stock:accessory:add'),
      // handleEdit: checkPermission('handleEdit'),
      removeEnable: checkPermission('stock:accessory:remove'),

      removeEnable2: checkPermission('stock:accessory:remove2')
    }
  },
  filters: {},
  async created() {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })

    selectenterprise({}).then(res => {
      console.log(res)
      this.boxLis4 = res.rows
    })
    selectenterprise({}).then(res => {
      console.log(res)
      this.boxLis4 = res.rows
    })

    selectaccessory().then(res => {
      console.log(res)
      this.boxLis5 = res.rows
      console.log(this.boxLis)
    })

    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('delivery_company')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.restaurantTypes.push({ code: key, label: value })
    })

    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('store_order_type')
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })
  },
  methods: {
    handClear() {
      this.queryParam = {}
      this.timess = ''
      this.timess2 = ''
      this.time4 = ''
      this.timess3 = ''
      this.time2 = ''
      this.time3 = ''
      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
      this.completionTimeStart = ''
      this.completionTimeEnd = ''

      this.timeBegin = ''
      this.timeEnd = ''

      this.expectedDeliveryTimeStart = ''
      this.expectedDeliveryTimeEnd = ''

      this.paymentCompletionTimeStart = ''
      this.paymentCompletionTimeEnd = ''
    },

    //查询时间2
    onChangeTiem4(value) {
      this.time3 = value
      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
      this.completionTimeStart = ''
      this.completionTimeEnd = ''

      this.timeBegin = ''
      this.timeEnd = ''

      this.expectedDeliveryTimeStart = ''
      this.expectedDeliveryTimeEnd = ''

      this.paymentCompletionTimeStart = ''
      this.paymentCompletionTimeEnd = ''
    },

    // 查询时间
    onChangeTiem6(value) {
      this.time4 = value

      this.needTimeStart = ''
      this.createTimeStart = ''
      this.auditTimeStart = ''
      this.needTimeEnd = ''
      this.createTimeEnd = ''
      this.auditTimeEnd = ''
      this.completionTimeStart = ''
      this.completionTimeEnd = ''

      this.timeBegin = ''
      this.timeEnd = ''

      this.expectedDeliveryTimeStart = ''
      this.expectedDeliveryTimeEnd = ''

      this.paymentCompletionTimeStart = ''
      this.paymentCompletionTimeEnd = ''
    },
    onChangeTiem5(data, timeString) {
      if (this.time4 === 0 || this.time3 === 0) {
        this.needTimeStart = timeString[0]
        this.needTimeEnd = timeString[1]
      } else if (this.time4 == 1 || this.time3 == 1) {
        this.createTimeStart = timeString[0]
        this.createTimeEnd = timeString[1]
      } else if (this.time4 == 2 || this.time3 == 2) {
        this.completionTimeStart = timeString[0]
        this.completionTimeEnd = timeString[1]
      } else if (this.time4 == 3 || this.time3 == 3) {
        this.timeBegin = timeString[0]
        this.timeEnd = timeString[1]
      } else if (this.time4 == 4 || this.time3 == 4) {
        this.expectedDeliveryTimeStart = timeString[0]
        this.expectedDeliveryTimeEnd = timeString[1]
      } else if (this.time4 == 5 || this.time3 == 5) {
        this.paymentCompletionTimeStart = timeString[0]
        this.paymentCompletionTimeEnd = timeString[1]
      }

      console.log(data, timeString)
    },

    detailBtn(record) {
      this.orderId = record.orderId
      this.processInstanceId = record.processInstanceId

      var forbiddenStatus = record.forbiddenStatus
      if (record.forbiddenStatus == '0') {
        var forbiddenStatus = '1'
      } else {
        var forbiddenStatus = '0'
      }

      if (record.orderType == '调拨单') {
        this.orderType = 0
      } else if (record.orderType == '调货单') {
        this.orderType = 1
      } else if (record.orderType == '退货单') {
        this.orderType = 2
      } else {
        this.orderType = 3
      }
      const orderList = {
        orderId: this.orderId,
        forbiddenStatus: forbiddenStatus,
        orderType: this.orderType
      }
      forbiddenorder(orderList).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.boxLis = res.rows
          console.log(this.boxLis)
          console.log(this.commonFlag)
          this.$message.success('操作成功')
          if (record.forbiddenStatus == '0') {
            record.forbiddenStatus = '1'
          } else {
            record.forbiddenStatus = '0'
          }
          // this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    //获取供应商Id
    onChange3(values) {
      this.supplierId = values
      console.log(this.boxLis)
      var boxLis = this.boxLis
      for (let i = 0; i < boxLis.length; i++) {
        if (values == boxLis[i].supplierId) {
          this.supplierName = boxLis[i].supplierName
        }
      }
      console.log(values)
    },

    //查询时间
    onChangeTiem2(value) {
      console.log(value)
      this.time2 = value
    },

    // onChangeTiem3(time, timeString){
    //   if(this.time2==0){
    //     this.needTimeStart = timeString[0]
    //     this.needTimeEnd = timeString[1]
    //   }else if(this.time2==1){
    //     this.createTimeStart = timeString[0]
    //     this.createTimeEnd = timeString[1]
    //   }else{
    //     this.auditTimeStart = timeString[0]
    //     this.auditTimeEnd = timeString[1]
    //   }
    //
    //   console.log(time, timeString);
    // },

    //获取配件Id
    onchange2(values) {
      console.log(values)
      this.accessoryId = values
      let boxLis = this.boxLis
      for (let i = 0; i < boxLis.length; i++) {
        if (boxLis[i].accessoryId == values) {
          this.accessoryId = boxLis[i].accessoryId
          this.accessoryName = boxLis[i].accessoryName
        }
      }
    },

    // //获取供应商Id
    // onChange3(values){
    //   this.supplierId = values
    //   console.log(this.boxLis5)
    //   var boxLis = this.boxLis5
    //   for(let i=0;i<boxLis.length;i++){
    //     if(values == boxLis[i].supplierId){
    //       this.supplierName = boxLis[i].supplierName
    //     }
    //   }
    //   console.log(values)
    // },

    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      console.log(record)
      if (record.forbiddenStatus == 1) {
        if (record.operateType == 1 || record.operateType == 3) {
          this.$message.success('请先作废')
        } else {
          if (record.orderType == '调货单') {
            this.$refs.modal.edit(record)
          } else if (record.orderType == '退货单') {
            this.$refs.modal2.edit(record)
          } else if (record.orderType == '调拨单') {
            this.$refs.modal3.edit(record)
          } else if (record.orderType == '报损单') {
            this.$refs.modal.edit(record)
          }
        }
      } else {
        if (record.orderType == '调货单') {
          this.$refs.modal.edit(record)
        } else if (record.orderType == '退货单') {
          this.$refs.modal2.edit(record)
        } else if (record.orderType == '调拨单') {
          this.$refs.modal3.edit(record)
        } else if (record.orderType == '报损单') {
          this.$refs.modal.edit(record)
        }
      }
    },

    handleEdit2(record) {
      console.log(record)
      if (record.orderType == '报损单') {
        this.$refs.modal.edit(record)
      }
    },

    handleOk(userDefined) {
      console.log('userDeFined', userDefined)
      if (userDefined != undefined && userDefined[0] == 1) {
        this.$refs.table.refresh(false)
      } else {
        this.$refs.table.refresh(true)
      }
      console.log('handleSaveOk')
    },

    handleOk3(userDefined) {
      console.log('userDeFined', userDefined)
      if (userDefined != undefined && userDefined[0] == 1) {
        this.$refs.table.refresh(false)
      } else {
        this.$refs.table.refresh(true)
      }
      console.log('handleSaveOk')
    },

    handleSubmit2() {
      this.dateModel = false
      this.dateModel2 = true
      selectenterprise2({}).then(res => {
        console.log(res)
        this.boxLis2 = res.rows
        console.log(this.boxLis2)
      })
    },

    handleSubmit3(idsLis) {
      this.dateModel = false
      this.dateModel2 = true
      console.log(this.modelAccessories)
      console.log(this.enterprise)
      var modelAccessories = this.modelAccessories
      var enterprise = this.enterprise
      var idsLis = this.ids
      // this.enterprise = {
      //   enterprise:modelAccessories
      // }
      // this.modelAccessories ={
      //   modelAccessories:enterprise
      // }
      // this.accessory = {
      //   accessoryId:idsLis,
      //   enterprise:this.enterprise,
      //   modelAccessories:this.modelAccessories
      // }
      configSave({ accessoryId: this.ids, enterprise: this.enterprise, modelAccessories: this.modelAccessories }).then(
        res => {
          console.log(res)
          this.boxLis2 = res.rows
          // for(var i=0;i<res.rows.length;i++){
          //     var boxLis2 = res.rows[i].brand
          //   for(var j=0;j<boxLis2.length;j++){
          //     this.boxLis3 = boxLis2[j]
          //   }
          // }
          console.log(this.boxLis2)

          this.array1 = []
        }
      )
    },

    delByIds(record) {
      let that = this
      that.orderId = record.orderId
      that.forbiddenStatus = record.forbiddenStatus
      if (that.forbiddenStatus == 0) {
        that.$message.success('请先作废')
      } else {
        if (record.orderType == '调拨单') {
          that.orderType = 0
        } else if (record.orderType == '调货单') {
          that.orderType = 1
        } else if (record.orderType == '退货单') {
          that.orderType = 2
        } else {
          that.orderType = 3
        }
        const orderList = {
          orderId: that.orderId,
          forbiddenStatus: that.forbiddenStatus,
          orderType: that.orderType
        }

        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            delorder(orderList).then(res => {
              console.log(res)
              if (res.code === 0) {
                that.$message.success('删除成功')
                // that.handleOk()
                that.$refs.table.refresh(false)
              } else {
                that.$message.error(res.msg)
              }
              that.selectedRowKeys = []
            })
          },
          onCancel() {
            console.log('Cancel')
          }
        })
      }
    },

    delById(record) {
      var forbiddenStatus = record.forbiddenStatus
      if (record.forbiddenStatus == '启用') {
        var forbiddenStatus = 1
      } else {
        var forbiddenStatus = 0
      }
      var accessoryId = record.accessoryId
      delAccessoryTwo({ accessoryId: accessoryId, forbiddenStatus: forbiddenStatus }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    }
  },

  watch: {
    checkedKeys(val) {
      console.log('modelAccessories', val)
      this.enterprise = val
      console.log(this.enterprise)
      //this.delByIds = val;
    }
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
